import { useViewport } from '@tryhackme/thm-ui-components';
import { useMemo, useRef } from 'react';
import { useCountdown } from 'src/common/hooks/use-countdown';
import { ReactComponent as Crown } from 'src/images/svgs/campaigns/crown.svg';
import { useTheme } from 'styled-components';
import { CountdownWrapper, DecorativeImage, Separator, TimeCard, TimeLabel, TimeValue } from './countdown-with-background.styles';
type Dimensions = {
  width: number;
  height: number;
};
export const CountdownWithBackground = ({
  endTime
}: {
  endTime: number;
}) => {
  const hRef = useRef<HTMLElement>(null);
  const mRef = useRef<HTMLElement>(null);
  const sRef = useRef<HTMLElement>(null);
  const {
    width: viewportWidth
  } = useViewport();
  const theme = useTheme();
  const {
    card,
    crown,
    crownOffsets
  } = useMemo(() => {
    const lgBreakpoint = Number.parseInt(theme.sizes.lg, 10);
    const isLargeScreen = viewportWidth >= lgBreakpoint;
    const {
      card,
      crown
    } = isLargeScreen ? {
      card: {
        width: 8.6,
        height: 8.4
      },
      crown: {
        width: 6.2,
        height: 3.8
      }
    } : {
      card: {
        width: 6.4,
        height: 6.2
      },
      crown: {
        width: 4.3,
        height: 2.6
      }
    };
    const baseTop = (crown.height - card.height) / 2;
    const baseRight = (crown.width - card.width) / 2;

    // Magic number adjustments make crown fit snuggly on card
    const crownOffsets = {
      top: isLargeScreen ? baseTop - 0.2 : baseTop + 0.1,
      right: isLargeScreen ? baseRight - 0.3 : baseRight + 0.05
    };
    return {
      card,
      crown,
      crownOffsets
    };
  }, [viewportWidth, theme]);
  useCountdown([undefined, hRef, mRef, sRef, undefined], endTime);
  return <CountdownWrapper data-testid="countdown-with-background" data-sentry-element="CountdownWrapper" data-sentry-component="CountdownWithBackground" data-sentry-source-file="countdown-with-background.tsx">
      <TimeCard $width={card.width} $height={card.height} data-sentry-element="TimeCard" data-sentry-source-file="countdown-with-background.tsx">
        <TimeValue ref={hRef as React.RefObject<HTMLParagraphElement>} data-sentry-element="TimeValue" data-sentry-source-file="countdown-with-background.tsx">00</TimeValue>
        <TimeLabel data-sentry-element="TimeLabel" data-sentry-source-file="countdown-with-background.tsx">Hr</TimeLabel>
      </TimeCard>

      <Separator data-sentry-element="Separator" data-sentry-source-file="countdown-with-background.tsx">:</Separator>

      <TimeCard $width={card.width} $height={card.height} data-sentry-element="TimeCard" data-sentry-source-file="countdown-with-background.tsx">
        <TimeValue ref={mRef as React.RefObject<HTMLParagraphElement>} data-sentry-element="TimeValue" data-sentry-source-file="countdown-with-background.tsx">00</TimeValue>
        <TimeLabel data-sentry-element="TimeLabel" data-sentry-source-file="countdown-with-background.tsx">Min</TimeLabel>
      </TimeCard>

      <Separator data-sentry-element="Separator" data-sentry-source-file="countdown-with-background.tsx">:</Separator>

      <TimeCard $width={card.width} $height={card.height} data-sentry-element="TimeCard" data-sentry-source-file="countdown-with-background.tsx">
        <TimeValue ref={sRef as React.RefObject<HTMLParagraphElement>} data-sentry-element="TimeValue" data-sentry-source-file="countdown-with-background.tsx">00</TimeValue>
        <TimeLabel data-sentry-element="TimeLabel" data-sentry-source-file="countdown-with-background.tsx">Sec</TimeLabel>

        <DecorativeImage $width={crown.width} $height={crown.height} $top={crownOffsets.top} $right={crownOffsets.right} data-sentry-element="DecorativeImage" data-sentry-source-file="countdown-with-background.tsx">
          <Crown data-sentry-element="Crown" data-sentry-source-file="countdown-with-background.tsx" />
        </DecorativeImage>
      </TimeCard>
    </CountdownWrapper>;
};